<template>
  <v-card>
    <v-card-title class="headline grey lighten-2" primary-title>
      List of Transaction to Match
      <v-spacer></v-spacer>
      <v-btn text icon @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-flex xs12>
        <form data-vv-scope="selectTransToMatchFilterForm">
          <v-expansion-panels v-model="filtersTransPanel" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex lg4 xs4>
                          <cal-picker
                            v-model="filtersTransToMatch.transactionDateFrom"
                            :label="filtersTransToMatchLabel.transactionDateFrom"
                            :data-vv-as="filtersTransToMatchLabel.transactionDateFrom"
                            data-vv-name="filtersTransToMatch.transactionDateFrom"
                          ></cal-picker>
                        </v-flex>
                        <v-flex lg4 xs4>
                          <cal-picker
                            v-model="filtersTransToMatch.transactionDateTo"
                            :label="filtersTransToMatchLabel.transactionDateTo"
                            :data-vv-as="filtersTransToMatchLabel.transactionDateTo"
                            data-vv-name="filtersTransToMatch.transactionDateTo"
                          ></cal-picker>
                        </v-flex>
                        <v-flex lg4 xs4>
                          <v-checkbox
                            color="primary"
                            :label="filtersTransToMatchLabel.includeTranWithZero"
                            v-model="filtersTransToMatch.includeTranWithZero"
                          ></v-checkbox>
                        </v-flex>
                        <v-flex xs12> </v-flex>
                        <v-flex xs4>
                          <v-checkbox
                            color="primary"
                            :label="filtersTransToMatchLabel.differentBranchCode"
                            v-model="filtersTransToMatch.differentBranchCode"
                          ></v-checkbox>
                        </v-flex>
                        <v-flex xs4>
                          <v-checkbox
                            color="primary"
                            :label="filtersTransToMatchLabel.differentAccountMonth"
                            v-model="filtersTransToMatch.differentAccountMonth"
                          ></v-checkbox>
                        </v-flex>
                        <v-flex xs4>
                          <v-checkbox
                            color="primary"
                            :label="filtersTransToMatchLabel.differentAccountYear"
                            v-model="filtersTransToMatch.differentAccountYear"
                          ></v-checkbox>
                        </v-flex>
                        <v-flex xs4>
                          <v-text-field
                            v-model="filtersTransToMatch.policyNo"
                            :label="filtersTransToMatchLabel.policyNo"
                            :error-messages="errors.collect('filtersTransToMatch.policyNo')"
                            data-vv-name="filtersTransToMatch.policyNo"
                            :data-vv-as="filtersTransToMatchLabel.policyNo"
                          >
                            <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                              <v-icon color="info" @click=";(showAcctPolicyHelpList = true), checkAction('policyNo')">mdi-magnify</v-icon>
                            </v-slide-x-reverse-transition>
                          </v-text-field>
                        </v-flex>
                        <v-flex xs4>
                          <v-text-field
                            v-model="filtersTransToMatch.branch"
                            :label="filtersTransToMatchLabel.branch"
                            :disabled="!filtersTransToMatch.differentBranchCode"
                            :error-messages="errors.collect('filtersTransToMatch.branch')"
                            data-vv-name="filtersTransToMatch.branch"
                            :data-vv-as="filtersTransToMatchLabel.branch"
                          >
                            <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                              <v-icon
                                color="info"
                                @click=";(showAcctPolicyHelpList = true), checkAction('branch')"
                                :disabled="!filtersTransToMatch.differentBranchCode"
                              >mdi-magnify</v-icon>
                            </v-slide-x-reverse-transition>
                          </v-text-field>
                        </v-flex>
                        <v-flex xs4>
                          <v-autocomplete
                            :items="tranType"
                            v-model="filtersTransToMatch.tranType"
                            :label="filtersTransToMatchLabel.tranType"
                            item-text="text"
                            item-value="value"
                            data-vv-name="filtersTransToMatch.tranType"
                            :data-vv-as="filtersTransToMatchLabel.tranType"
                            :error-messages="errors.collect('filtersTransToMatch.tranType')"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex xs4>
                          <v-text-field
                            v-model="filtersTransToMatch.documentNo"
                            :label="filtersTransToMatchLabel.documentNo"
                            :error-messages="errors.collect('filtersTransToMatch.documentNo')"
                            data-vv-name="filtersTransToMatch.documentNo"
                            :data-vv-as="filtersTransToMatchLabel.documentNo"
                          >
                            <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                              <v-icon
                                color="info"
                                @click=";(showAcctPolicyHelpList = true), checkAction('documentNo')"
                              >mdi-magnify</v-icon>
                            </v-slide-x-reverse-transition>
                          </v-text-field>
                        </v-flex>
                        <v-flex xs4>
                          <v-text-field
                            v-model="filtersTransToMatch.fund"
                            :label="filtersTransToMatchLabel.fund"
                            :disabled="!filtersTransToMatch.multiFundSfxCurr"
                            :error-messages="errors.collect('filtersTransToMatch.fund')"
                            data-vv-name="filtersTransToMatch.fund"
                            :data-vv-as="filtersTransToMatchLabel.fund"
                            v-validate="'entry|max:60'"
                          >
                            <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                              <v-icon color="info" @click="showFundHelpList = true">mdi-magnify</v-icon>
                            </v-slide-x-reverse-transition>
                          </v-text-field>
                        </v-flex>
                        <v-flex xs4>
                          <v-text-field
                            v-model="filtersTransToMatch.accountNoSuffix"
                            :label="filtersTransToMatchLabel.accountNoSuffix"
                            :disabled="!filtersTransToMatch.multiFundSfxCurr"
                            :error-messages="errors.collect('filtersTransToMatch.accountNoSuffix')"
                            data-vv-name="filtersTransToMatch.accountNoSuffix"
                            :data-vv-as="filtersTransToMatchLabel.accountNoSuffix"
                            v-validate="'entry|max:60'"
                          >
                            <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                              <v-icon color="info" @click="showAcctSufHelpList = true">mdi-magnify</v-icon>
                            </v-slide-x-reverse-transition>
                          </v-text-field>
                        </v-flex>
                        <v-flex xs4>
                          <v-text-field
                            v-model="filtersTransToMatch.currency"
                            :label="filtersTransToMatchLabel.currency"
                            :error-messages="errors.collect('filtersTransToMatch.currency')"
                            data-vv-name="filtersTransToMatch.currency"
                            :data-vv-as="filtersTransToMatchLabel.currency"
                            v-validate="'entry|max:60'"
                            :disabled="!filtersTransToMatch.multiFundSfxCurr"
                          >
                            <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                              <v-icon color="info" @click="showCurrHelpList = true">mdi-magnify</v-icon>
                            </v-slide-x-reverse-transition>
                          </v-text-field>
                        </v-flex>
                        <v-flex xs4>
                          <v-text-field
                            v-model="filtersTransToMatch.osBalMoreThan"
                            :label="filtersTransToMatchLabel.osBalMoreThan"
                            :error-messages="errors.collect('filtersTransToMatch.osBalMoreThan')"
                            data-vv-name="filtersTransToMatch.osBalMoreThan"
                            :data-vv-as="filtersTransToMatchLabel.osBalMoreThan"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs4>
                          <v-text-field
                            v-model="filtersTransToMatch.osBalMoreLess"
                            :label="filtersTransToMatchLabel.osBalMoreLess"
                            :error-messages="errors.collect('filtersTransToMatch.osBalMoreLess')"
                            data-vv-name="filtersTransToMatch.osBalMoreLess"
                            :data-vv-as="filtersTransToMatchLabel.osBalMoreLess"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-layout row wrap>
                    <v-spacer></v-spacer>
                    <v-card-actions>
                      <v-btn color="red darken-1" text @click.native="doClearSelectedFilters">Clear Filters</v-btn>
                      <v-btn color="primary" text type="submit" @click.prevent="doSubmitFilters">Apply Filters</v-btn>
                    </v-card-actions>
                  </v-layout>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-flex xs12 class="mt-2">
        <v-data-table
          v-if="UUID === undefined || UUID === null"
          v-bind:headers="listTransToMatch"
          v-bind:items="transToMatchItems"
          v-bind:options.sync="paginationMatch"
          :footer-props="{'items-per-page-options': itemsPerPage }"
          :server-items-length="totalItemsMatch"
          :loading="loading"
          :no-data-text="noDataText"
          v-model="matchSelected"
          show-select
          class="elevation-1"
          item-key="key"
        >
        </v-data-table>
        <v-data-table
          v-else
          v-bind:headers="listTransToMatch"
          v-bind:items="transToMatchItems"
          v-bind:options.sync="paginationMatch"
          :footer-props="{'items-per-page-options': itemsPerPage }"
          :loading="loading"
          :no-data-text="noDataText"
          v-model="matchSelected"
          show-select
          class="elevation-1"
          item-key="key"
        >
        </v-data-table>
        <v-btn class="mt-2 mr-2" color="red" dark @click.prevent="doClearSelected"> Clear<v-icon dark right>mdi-eraser</v-icon> </v-btn>
        <v-btn class="mt-2" color="blue" dark @click.prevent="doSelected">
          Apply Selected Transaction<v-icon dark right>mdi-marker-check</v-icon>
        </v-btn>
      </v-flex>
    </v-card-text>

    <v-dialog v-model="showAcctPolicyHelpList" width="1280px">
      <acct-policy-help-list2
        :acctNo="matchData.accountNo"
        :boolRefresh="showAcctPolicyHelpList"
        :actionName="action"
        @close="showAcctPolicyHelpList = false"
        @assign-acctData="assignAcctData"
      ></acct-policy-help-list2>
    </v-dialog>

    <v-dialog v-model="showFundHelpList" width="1280px">
      <fund-help-list @close="showFundHelpList = false" @assign-fund="assignFund"></fund-help-list>
    </v-dialog>

    <v-dialog v-model="showAcctSufHelpList" width="1280px">
      <acct-suf-help-list @close="showAcctSufHelpList = false" @assign-acct-suf="assignAcctSuf"></acct-suf-help-list>
    </v-dialog>

    <v-dialog v-model="showCurrHelpList" width="1280px">
      <cr-currency-help-list @close="showCurrHelpList = false" @assign-currency="assignCurrency"></cr-currency-help-list>
    </v-dialog>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { matchAjaxMixin } from '@/mixins/accounting/match/matchAjaxMixin'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import AcctPolicyHelpList2 from '@/components/core/common/dialog/AcctPolicyHelpList2'
import { matchFilterMixin } from '@/mixins/accounting/match/matchFilterMixin'
import FundHelpList from '@/components/core/common/dialog/FundHelpList'
import AcctSufHelpList from '@/components/core/common/dialog/AcctSufHelpList'
import CrCurrencyHelpList from '@/components/core/common/dialog/CrCurrencyHelpList'
import { formatPrice } from '@/utils/index'

export default {
  data() {
    return {
      filtersTransToMatchLabel: {
        transactionDateFrom: 'Transaction Date From',
        transactionDateTo: 'Transaction Date To',
        includeTranWithZero: 'Include transactions with zero (0.00) balance',
        differentBranchCode: 'Different Branch Code',
        differentAccountMonth: 'Different Accounting Month',
        differentAccountYear: 'Different Accounting Year',
        policyNo: 'Policy No',
        branch: 'Branch',
        documentNo: 'Document No.',
        tranType: 'Type',
        fund: 'Fund',
        accountNoSuffix: 'Suffix',
        currency: 'Currency',
        osBalMoreThan: 'Outstanding Balance more than',
        osBalMoreLess: 'Outstanding Balance less than'
      },
      filtersTransToMatch: {
        transactionDateFrom: '',
        transactionDateTo: '',
        includeTranWithZero: false,
        differentBranchCode: false,
        differentAccountMonth: true,
        differentAccountYear: true,
        accountNo: '',
        accountYear: '',
        accountMonth: '',
        multiFundSfxCurr: '',
        policyNo: '',
        branch: '',
        tranType: '',
        documentNo: '',
        fund: '',
        accountNoSuffix: '',
        currency: '',
        osBalMoreThan: '',
        osBalMoreLess: ''
      },
      matchSelected: [],
      transToMatchItems: [],
      totalItemsMatch: 0,
      selectedTransToMatchColumns: ['tranDate', 'polNo', 'acctNo', 'branch', 'type', 'docNo', 'fund', 'suffix', 'curr', 'netAmt', 'osBal', 'comm'],
      transToMatchColumns: [
        { text: 'Tran Date', align: 'left', value: 'tranDate' },
        { text: 'Policy No.', align: 'left', value: 'polNo' },
        { text: 'Acct No.', align: 'left', value: 'acctNo' },
        { text: 'Branch', align: 'left', value: 'branch' },
        { text: 'Type', align: 'left', value: 'type' },
        { text: 'Doc No.', align: 'left', value: 'docNo' },
        { text: 'Fund ', align: 'left', value: 'fund' },
        { text: 'Suffix', align: 'left', value: 'suffix' },
        { text: 'Curr', align: 'left', value: 'curr' },
        { text: 'Net Amt', align: 'left', value: 'netAmt' },
        { text: 'O/S Bal', align: 'left', value: 'osBal' },
        { text: 'Comm', align: 'left', value: 'comm' }
      ],
      paginationMatch: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 10
      },
      miscacctparams: [],
      showAcctPolicyHelpList: false,
      action: null,
      showFundHelpList: false,
      showAcctSufHelpList: false,
      showCurrHelpList: false,
      filtersTransPanel: [],
      sItems: [],
      selectedRow: [],
      isAfterDefFilter: false
    }
  },
  computed: {
    matchData() {
      return this.$store.state.matching.matchData
    },
    listTransToMatch() {
      let result = []
      for (const selectedTransToMatchColumn of this.selectedTransToMatchColumns) {
        let findCol = this.transToMatchColumns.find((a) => selectedTransToMatchColumn === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      return result
    },
    UUID() {
      return this.$store.state.accounts.acctMchObj.UUID
    },
    selectFromMatch() {
      return this.$store.state.accounts.acctMchObj.selectFromMatch
    },
    matchFileName() {
      return this.$store.state.accounts.acctMchObj.matchFileName
    }
  },
  methods: {
    async doInit() {
      this.loading = true
      this.filtersTransPanel = [0]
      await Promise.all([this.$store.dispatch('commonsInit')])
      if (this.$store.state.accounts.init === 0) {
        await Promise.all([this.$store.dispatch('accountsInit')])
      }
      await Promise.all([this.$store.dispatch('performMatchInit')])
      // this.filtersTransToMatch.transactionDateFrom = new Date()
      // this.filtersTransToMatch.transactionDateTo = new Date()
      this.getCommonData('miscacctparams').then((result) => {
        this.filtersTransToMatch.multiFundSfxCurr = this.miscacctparams.multiFundSfxCurr
        this.doSelectedFilters()
        this.isAfterDefFilter = true
      })
      this.matchSelected = this.matchDetItems
    },
    selectItem(item) {
      let index = this.selectedRow.indexOf(item.key)
      if (this.selectedRow.includes(item.key)) {
        this.selectedRow = this.selectedRow.filter((id) => id !== item.key)
        this.matchSelected.splice(index, 1)
      } else {
        this.selectedRow.push(item.key)
        this.matchSelected.push(item)
      }
    },
    formatPrice(data) {
      return formatPrice(data)
    },
    closeDialog() {
      this.resetFilterForm()
      this.$emit('close')
    },
    doClearSelectedFilters() {
      this.resetFilterForm()
      this.doSelectedFilters()
    },
    resetFilterForm() {
      this.filtersTransToMatch.transactionDateFrom = ''
      this.filtersTransToMatch.transactionDateTo = ''
      this.filtersTransToMatch.includeTranWithZero = false
      this.filtersTransToMatch.differentBranchCode = false
      this.filtersTransToMatch.differentAccountMonth = true
      this.filtersTransToMatch.differentAccountYear = true
      this.filtersTransToMatch.accountNo = ''
      this.filtersTransToMatch.accountYear = ''
      this.filtersTransToMatch.accountMonth = ''
      this.filtersTransToMatch.policyNo = ''
      this.filtersTransToMatch.branch = ''
      this.filtersTransToMatch.tranType = ''
      this.filtersTransToMatch.documentNo = ''
      this.filtersTransToMatch.fund = ''
      this.filtersTransToMatch.accountNoSuffix = ''
      this.filtersTransToMatch.currency = ''
      this.filtersTransToMatch.osBalMoreThan = ''
      this.filtersTransToMatch.osBalMoreLess = ''
      this.transToMatchItems = []
    },
    doSubmitFilters() {
      this.doSelectedFilters()
    },
    doSelectedFilters() {
      this.filtersTransToMatch.accountNo = this.matchData.accountNo
      this.filtersTransToMatch.accountYear = this.matchData.acctYr
      this.filtersTransToMatch.accountMonth = this.matchData.acctMth
      this.sItems = this.matchDetItems
      this.getMatchDataList()
    },
    doClearSelected() {
      this.matchSelected = []
    },
    doSelectAll() {
      this.matchSelected = this.transToMatchItems
    },
    doSelected() {
      var tempMatchSelected = []
      for (var a = 0; a < this.matchSelected.length; a++) {
        var foundMatchSelected = false
        for (var b = 0; b < this.matchDetItems.length; b++) {
          if (
            this.matchDetItems[b].polNo === this.matchSelected[a].polNo &&
            this.matchDetItems[b].branch === this.matchSelected[a].branch &&
            this.matchDetItems[b].type === this.matchSelected[a].type &&
            this.matchDetItems[b].docNo === this.matchSelected[a].docNo &&
            this.matchDetItems[b].fund === this.matchSelected[a].fund &&
            this.matchDetItems[b].suffix === this.matchSelected[a].suffix
          ) {
            foundMatchSelected = true
          }
        }
        if (foundMatchSelected === false) {
          tempMatchSelected.push(this.matchSelected[a])
        }
      }
      this.resetFilterForm()
      this.$emit('assign-matchSelected', tempMatchSelected)
      this.$emit('close')
    },
    assignAcctData(data, action) {
      if (action === 'policyNo') {
        this.filtersTransToMatch.policyNo = data
      } else if (action === 'branch') {
        this.filtersTransToMatch.branch = data
      } else if (action === 'documentNo') {
        this.filtersTransToMatch.documentNo = data
      }
    },
    assignFund(data) {
      this.filtersTransToMatch.fund = data
    },
    assignAcctSuf(data) {
      this.filtersTransToMatch.accountNoSuffix = data
    },
    assignCurrency(data) {
      this.filtersTransToMatch.currency = data
    },
    checkAction(data) {
      this.action = data
    }
  },
  mounted() {
    this.doInit()
  },
  watch: {
    'paginationMatch': function (value) {
      if (this.isAfterDefFilter === true) {
        this.getMatchDataList()
      }
    }
  },
  mixins: [TableConst.default, matchAjaxMixin, commonAjaxMixin, matchFilterMixin],
  components: {
    AcctPolicyHelpList2,
    FundHelpList,
    AcctSufHelpList,
    CrCurrencyHelpList
  },
  props: {
    matchDetItems: {
      type: Array
    },
    refresh: {
      type: Boolean,
      default: true
    }
  }
}
</script>
